import type { Locale } from '@/config/locales';
import type { SplitClaimPanelLabels } from '@/components/session/SplitClaimPanel';

const es: SplitClaimPanelLabels = {
  methodTitle: '¿Cómo quieres dividir?',
  methods: {
    consumi: 'Solo lo que consumí',
    iguales: 'Dividir en partes iguales',
    articulos: 'Elegir artículos o fracciones',
    monto: 'Elegir un monto',
  },
  amountPlaceholder: 'Monto en MXN',
  confirm: 'Tomar esta parte',
  amountErrors: {
    below_minimum: 'El monto es menor al mínimo permitido.',
    exceeds_balance: 'El monto supera el saldo sin asignar.',
    invalid: 'Introduce un monto válido.',
  },
  itemsTitle: 'Elige un artículo',
  fractionLabel: 'Mi parte',
  wholeItem: 'Artículo completo',
  equalTitle: 'Dividir todo lo restante entre',
  equalConfirm: 'Dividir en partes iguales',
  conflict: 'Otra persona tomó esa parte antes. Actualizamos la cuenta; elige de nuevo.',
  failed: 'No se pudo tomar esa parte. Inténtalo otra vez.',
  unavailable: 'No se pudo leer el saldo sin asignar. Pide ayuda al personal.',
  myShare: 'Mi parte',
};

const ko: SplitClaimPanelLabels = {
  methodTitle: '어떻게 나눌까요?',
  methods: {
    consumi: '내가 먹은 것만',
    iguales: '똑같이 나누기',
    articulos: '항목·분수로 고르기',
    monto: '금액 직접 정하기',
  },
  amountPlaceholder: 'MXN 금액',
  confirm: '내 몫으로 가져오기',
  amountErrors: {
    below_minimum: '최소 결제 금액보다 적습니다.',
    exceeds_balance: '남은 금액보다 큽니다.',
    invalid: '올바른 금액을 입력해 주세요.',
  },
  itemsTitle: '항목을 선택하세요',
  fractionLabel: '내 몫',
  wholeItem: '항목 전부',
  equalTitle: '남은 금액을 다음 인원으로 나누기',
  equalConfirm: '똑같이 나누기',
  conflict: '다른 분이 먼저 가져갔습니다. 최신 계산서에서 다시 골라 주세요.',
  failed: '몫을 가져오지 못했습니다. 다시 시도해 주세요.',
  unavailable: '남은 계산서를 불러오지 못했습니다. 직원에게 문의해 주세요.',
  myShare: '내 몫',
};

const en: SplitClaimPanelLabels = {
  methodTitle: 'How would you like to split?',
  methods: {
    consumi: 'Only what I had',
    iguales: 'Split equally',
    articulos: 'Choose items or fractions',
    monto: 'Choose an amount',
  },
  amountPlaceholder: 'Amount in MXN',
  confirm: 'Take this share',
  amountErrors: {
    below_minimum: 'The amount is below the minimum.',
    exceeds_balance: 'The amount is more than the unassigned balance.',
    invalid: 'Enter a valid amount.',
  },
  itemsTitle: 'Choose an item',
  fractionLabel: 'My share',
  wholeItem: 'Whole item',
  equalTitle: 'Split everything remaining between',
  equalConfirm: 'Split equally',
  conflict: 'Someone took that share first. The bill is up to date; choose again.',
  failed: 'Could not take that share. Please try again.',
  unavailable: 'The unassigned balance could not be read. Please ask a staff member.',
  myShare: 'My share',
};

export function getSplitClaimLabels(locale: Locale | null | undefined): SplitClaimPanelLabels {
  if (locale === 'es') return es;
  if (locale === 'ko') return ko;
  return en;
}
